import { observer } from "mobx-react-lite";
import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import ChargeTypeDetailViewModel from "viewModels/timeCharges/chargeTypes/chargeTypeDetailViewModel";
import ChargeTypeForm from "./chargeTypeForm";
import DetailView from "views/common/detailView";

const ChargeTypeDetailView: ViewComponent<ChargeTypeDetailViewModel> = observer(({ vm }) => {
  return <DetailView vm={vm} form={<ChargeTypeForm vm={vm} />} />;
});

registerView(ChargeTypeDetailView, ChargeTypeDetailViewModel);
